import React, { useCallback, useEffect, useState } from 'react';
import uniq from 'lodash/uniq';
import without from 'lodash/without';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SimpleDropDown } from '@yme/atoms/dropdown';
import { setFilterOptions, getProductCardLabels, getProductValueByOption, } from '@yme/pdp-components/ProductCard';
import { getRTL } from '@yme/selectors/common';
import { STARTING_METHOD_KEY } from '@yme/selectors/constants';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { buildKey, getClearedValue } from '@yme/utils/common';
import { EMPTY_DROPDOWN_LIST_SYMBOL } from './constants';
import { buildCommonOptions, getAvailableSkuByStartingMethodValue } from './helpers';
export function SelectStartingMethod({ productFilterOptions, variantsOfProduct, }) {
    const [dropDownPossibleOptions, setDropDownPossibleOptions] = useState([]);
    const isRightToLeft = useSelector(getRTL);
    const productStartingMethodValues = useSelector(getProductValueByOption(STARTING_METHOD_KEY));
    const productCardLabels = useSelector(getProductCardLabels);
    const dispatch = useDispatch();
    const history = useHistory();
    const { sku, rotation, shaftLength, startingMethod = '' } = productFilterOptions;
    const onSelectNewValue = useCallback((option) => {
        if (option.value && startingMethod !== option.value) {
            const currentVariant = getAvailableSkuByStartingMethodValue({
                colorVariants: variantsOfProduct,
                startingMethodValue: option.label,
                rotation,
                shaftLength,
            });
            if (currentVariant && currentVariant.sku !== sku) {
                dispatch(setFilterOptions({
                    // set main prop
                    startingMethod: option.label,
                    // set relative options
                    sku: currentVariant.sku,
                    rotation: currentVariant.rotation,
                    shaftLength: currentVariant.shaftLength,
                    controlMethod: currentVariant.controlMethod,
                }));
                history.push({
                    hash: currentVariant.sku,
                });
            }
        }
    }, [dispatch, history, rotation, shaftLength, sku, startingMethod, variantsOfProduct]);
    useEffect(() => {
        const possibleOptions = variantsOfProduct.map((item) => (item.rotation === rotation && item.shaftLength === shaftLength && item.startingMethod) ||
            '') || [];
        const result = without(uniq(possibleOptions), '');
        setDropDownPossibleOptions(result);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sku, rotation, shaftLength]);
    const isCurrentFilterExist = Boolean(productStartingMethodValues && productStartingMethodValues?.length);
    if (!isCurrentFilterExist) {
        return null;
    }
    const options = buildCommonOptions({
        allOptions: productStartingMethodValues,
        possibleOptions: dropDownPossibleOptions,
    });
    const isDropDownDisabled = dropDownPossibleOptions.length === 0;
    const selectedOption = isDropDownDisabled
        ? {
            value: 'empty',
            label: EMPTY_DROPDOWN_LIST_SYMBOL,
        }
        : {
            value: getClearedValue(startingMethod),
            label: startingMethod,
        };
    const finalDataTestId = buildKey('startingMethodDropDown');
    return (React.createElement(FlexWrapper, { mt: "24px", flexDirection: "column" },
        React.createElement(FlexWrapper, { mb: "8px" },
            React.createElement(RegularTextLevel3, { weight: 500 }, productCardLabels?.productCard_startingMethodAndTilt_label)),
        React.createElement(FlexWrapper, { gap: "12px", flexDirection: "column" },
            React.createElement(SimpleDropDown, { defaultOption: selectedOption, options: options, selectedOption: selectedOption, setSelectedOption: onSelectNewValue, isRightToLeft: isRightToLeft, isDisabled: isDropDownDisabled, dataTestId: finalDataTestId }))));
}
SelectStartingMethod.displayName = 'SelectStartingMethod_Component';
